import { useUserStore } from '@/store'
import { message } from 'antd'
import { useObserver } from 'mobx-react'
import React, { Suspense } from 'react'
import { Route, Switch, Redirect, useHistory } from 'react-router-dom'
import routes from '../../router/routes'
import { IS_ELECTRON } from '../../utils/config'
import Loading from '../Loading'

const getTitle = (titleName) => {
  return `${titleName} | CocoFax Web Control Panel`
}

const ContentMain = (props) => {
  const userStore = useUserStore()
  const history = useHistory()

  return useObserver(() => {
    const Routes = routes.map((c) => {
      const PageComponent = c.component
      const title = c.title || c.name

      // 判断权限
      if (c.role && typeof c.role === 'function') {
        // 验证不通过
        if (!c.role(userStore)) {
          // 如果用户数据是最新的，则提示消息
          if (userStore.isRequestUserInfo) {
            // message.warn('Permission denied')
          }
          return null
        }
      }

      return (
        <Route
          key={c.name}
          exact={!c.notExact}
          path={c.path}
          render={(renderProps) => {
            if (!IS_ELECTRON) {
              document.title = getTitle(c.title || c.name)
            }
            return (
              <Suspense fallback={<Loading />}>
                <PageComponent {...props} {...renderProps} title={title} pdfSrc={props.pdfSrc.bind(null, history)} />
              </Suspense>
            )
          }}
        />
      )
    })
    return (
      <Switch>
        {Routes}
        <Redirect path="/" to={{ pathname: '/dashboard' }} />
      </Switch>
    )
  })
}

export default ContentMain
